import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User opened the Shopify integration plugin',
  name: 'integration_plugin_opened',
  params: [],
};

export default META;
